<template>
  <div>
    <v-container class="py-12">
      <v-row class="d-flex align-stretch">
        <!-- Contact Information Section -->
        <v-col cols="12" md="6">
          <v-card elevation="4" class="pa-5 fill-height" rounded="xl">
            <v-card-title class="text-h5 font-weight-bold mb-4">
              Get in Touch
            </v-card-title>
            <v-card-text class="text-body-1">
              <p>
                We'd love to hear from you. Whether you're an investor, a
                partner, or just curious to learn more about Businesspe, feel
                free to reach out using the contact form or the details below.
              </p>

              <v-list class="mt-4">
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon color="primary">mdi-map-marker</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      >123 Cement Avenue, Builder Town, IN
                      600001</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-icon>
                    <v-icon color="primary">mdi-phone</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>+91 98765 43210</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-icon>
                    <v-icon color="primary">mdi-email</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      >support@businesspe.com</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Contact Form Section -->
        <v-col cols="12" md="6">
          <v-card elevation="4" class="pa-5 fill-height" rounded="xl">
            <v-card-title class="text-h5 font-weight-bold mb-4">
              Send Us a Message
            </v-card-title>

            <v-form
              ref="contactForm"
              @submit.prevent="submitForm"
              lazy-validation
            >
              <v-text-field
                v-model="form.name"
                label="Your Name"
                outlined
                dense
                required
              ></v-text-field>

              <v-text-field
                v-model="form.email"
                label="Your Email"
                outlined
                dense
                required
                type="email"
              ></v-text-field>

              <v-text-field
                v-model="form.subject"
                label="Subject"
                outlined
                dense
              ></v-text-field>

              <v-textarea
                v-model="form.message"
                label="Your Message"
                outlined
                rows="4"
                dense
                required
              ></v-textarea>

              <v-btn
                type="submit"
                color="primary"
                class="mt-4"
                :loading="loading"
              >
                Send Message
              </v-btn>
            </v-form>

            <v-alert
              v-if="successMessage"
              type="success"
              class="mt-4"
              border="start"
              colored-border
            >
              {{ successMessage }}
            </v-alert>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "ContactUs",
  data() {
    return {
      form: {
        name: "",
        email: "",
        subject: "",
        message: "",
      },
      successMessage: "",
      loading: false,
    };
  },
  methods: {
    submitForm() {
      this.loading = true;

      // Simulate form submission
      setTimeout(() => {
        this.loading = false;
        this.successMessage =
          "Thank you for contacting us! We'll get back to you soon.";
        this.form = {
          name: "",
          email: "",
          subject: "",
          message: "",
        };
        this.$refs.contactForm.resetValidation();
      }, 1500);
    },
  },
};
</script>

<style scoped>
p {
  line-height: 1.6;
}
</style>
